import { render, staticRenderFns } from "./group.vue?vue&type=template&id=0434d376&scoped=true&"
import script from "./group.vue?vue&type=script&lang=ts&"
export * from "./group.vue?vue&type=script&lang=ts&"
import style0 from "./group.vue?vue&type=style&index=0&id=0434d376&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0434d376",
  null
  
)

export default component.exports